import React, { useState, useEffect } from "react";
import { firebase } from "firebase/compat/app";
import { storage } from "../../../firebase";

const Dataloader = () => {
  const [folder, setFolder] = useState(null);
  const [uploadedUrls, setUploadedUrls] = useState([]);

  const handleFileUpload = async (event) => {
    const folder = event.target.files[0];
    setFolder(folder);
  };

  const handleUpload = async () => {
    if (!folder) {
      return;
    }

    const storageRef = storage().ref();
    const folderRef = storageRef.child(folder.name);
    const uploadTask = folderRef.put(folder);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        console.log(
          "Upload is " +
            (snapshot.bytesTransferred / snapshot.totalBytes) *
              100 +
            "% done"
        );
      },
      (error) => {
        console.log("Error uploading folder:", error);
      },
      async () => {
        const url = await uploadTask.snapshot.ref.getDownloadURL();
        setUploadedUrls((prevUrls) => [...prevUrls, url]);
      }
    );
  };

  return (
    <div className="flex items-center justify-center h-screen">
      <form className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-lg font-medium mb-4">Upload Folder</h2>
        <div className="relative mb-4">
          <input
            type="file"
            directory=""
            webkitdirectory=""
            className="p-1 rounded-md w-full border border-gray-400 bg-white focus:outline-none focus:border-blue-500"
            onChange={handleFileUpload}
          />
          <button className="absolute right-0 top-0 mr-2 mt-1 text-blue-500 text-sm">
            Choose Folder
          </button>
        </div>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md focus:outline-none"
          onClick={handleUpload}
        >
          Upload Folder
        </button>
      </form>
      <div className="flex flex-wrap -mx-2">
        {uploadedUrls.map((url) => {
          return (
            <div className="w-1/3 px-2 mb-4">
              <img
                src={url}
                className="w-full rounded-md shadow-md"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Dataloader;
